import { register, load } from "@shopify/theme-sections";
import $ from "jquery";

const selectors = {
	form: "[data-newsletter-form]",
	status: "[data-form-status]",
	listId: "[data-list-id]",
	noListId: ".js-no-list-id",
	firstName: "#first_name",
	lastName: "#last_name",
	email: "#email",
	nearestStore: "#nearest_store",
	recurringBuyer: "#recurring_buyer",
	uncheckAll: "[data-uncheck-all]"
};

const modifiers = {
	error: "error-message",
	success: "success-message"
};

register("newsletter-preferences", {
	formStatus: null,
	onLoad: function () {
		this.init();
	},
	init: function () {
		const $newsletterForm = document.querySelector(selectors.form);
		this.formStatus = document.querySelector(selectors.status);
		const $firstName = document.querySelector(selectors.firstName);
		const $lastName = document.querySelector(selectors.lastName);
		const $email = document.querySelector(selectors.email);
		const $nearestStore = document.querySelector(selectors.nearestStore);
		const $recurringBuyer = document.querySelector(
			selectors.recurringBuyer
		);
		const $customerInterests = $newsletterForm.elements.customer_interests;
		const $customerPreferences =
			$newsletterForm.elements.customer_preferences;
		const $listID = document.querySelector(selectors.listId);
		const $noListID = document.querySelector(selectors.noListId);
		const $uncheckAll = document.querySelector(selectors.uncheckAll);
		let self = this;

		document.addEventListener("DOMContentLoaded", () => {
			$uncheckAll.addEventListener("click", function (e) {
				e.preventDefault();
				$newsletterForm
					.querySelectorAll("input[type=checkbox]:checked")
					.forEach((element) => (element.checked = false));
			});

			$newsletterForm.addEventListener("submit", (e) => {
				e.preventDefault();

				if (!$listID) {
					self.formStatus.classList.remove("hide");
					self.formStatus
						.querySelector(".js-form-status")
						.classList.add(modifiers.error);
					$noListID.classList.remove("hide");
					return;
				}

				let customerInterests = [];
				let customerCollections = [];

				if ($customerInterests !== null) {
					$customerInterests.forEach((element) => {
						if (element.checked) {
							customerInterests.push(element.value);
						}
					});
				}

				if ($customerPreferences !== null) {
					$customerPreferences.forEach((element) => {
						if (element.checked) {
							customerCollections.push(element.value);
						}
					});
				}

				customerInterests = customerInterests.join(", ");
				customerCollections = customerCollections.join(", ");

				window.CF.customerReady(function () {
					window.CF.customer.set("newsletter_preferences", {
						collections: customerCollections,
						interests: customerInterests,
						nearest_store: $nearestStore.value,
						recurring_buyer: $recurringBuyer.checked
					});
					window.CF.customer
						.save()
						.then(function (errorObj) {
							if (errorObj) {
								self.triggerStatus("error");
							} else {
								let data = {
									g: `${$listID.value}`,
									$fields: `$source,$email,$consent_method,$consent_form_id,$origin,$first_name,$last_name,$interests,$collections,$recurringBuyer,favourite_Collections,Nearest_Store,HasKPMalready,Anrede,Akad_title`,
									$list_fields: "$consent",
									$timezone_offset: Math.abs(
										new Date().getTimezoneOffset() / 60
									),
									$source: "Newsletter Subscribe",
									$first_name: `${$firstName.value}`,
									$last_name: `${$lastName.value}`,
									$email: `${$email.value}`,
									$consent_method: "Notify Me",
									$origin: `${$email.value}`,
									$recurringBuyer: `${$recurringBuyer.checked}`,
									$interests: customerInterests.length
										? customerInterests
										: "Empty"
								};
								$.ajax({
									method: "POST",
									url: "https://a.klaviyo.com/ajax/subscriptions/subscribe",
									data: data
								}).done(function (response) {
									if (response.success) {
										let _learnq = window._learnq || [];

										_learnq.push([
											"identify",
											{
												$source: "Newsletter Subscribe",
												$first_name: `${$firstName.value}`,
												$last_name: `${$lastName.value}`,
												$email: `${$email.value}`,
												$consent_method: "Notify Me",
												$origin: `${$email.value}`,
												$recurringBuyer: `${$recurringBuyer.checked}`,
												$interests:
													customerInterests.length
														? customerInterests
														: "Empty",
												favourite_Collections:
													customerCollections.length
														? customerCollections
														: "Empty",
												Nearest_Store: `${$nearestStore.value}`,
												HasKPMalready:
													$recurringBuyer.checked
														? 1
														: 0,
												Anrede:
													window.customer.gender
														.toLowerCase()
														.replaceAll('"', "") ===
													"male"
														? "Herr"
														: "Frau",
												Akad_title:
													window.customer.akad_title
											}
										]);
										self.triggerStatus("success");
									} else {
										self.triggerStatus("error");
									}
								});
							}
						})
						.catch(function () {
							self.triggerStatus("error");
						});
				});
			});
		}); // end DOMContentLoaded
	},
	triggerStatus: function (status) {
		this.formStatus
			.querySelector(".js-form-status")
			.classList.add(`${modifiers[status]}`);
		this.formStatus.classList.remove("hide");
		this.formStatus.querySelector(`.${status}`).classList.remove("hide");

		this.hideStatus();
	},
	hideStatus: function () {
		let self = this;
		setTimeout(function () {
			self.formStatus.classList.add("hide");
			self.formStatus.querySelector(".success").classList.add("hide");
			self.formStatus.querySelector(".error").classList.add("hide");
		}, 2000);
	}
});

load("newsletter-preferences");
